import React, { PropsWithChildren } from "react"
import { Box, Flex, Spacer } from "@chakra-ui/layout"
import SectionHeading from "../../../../shared/text/heading"
import Paragraph from "../../../../shared/text/paragraph"
import Subheading from "../../../../shared/text/subheading"

interface Props {
    featured: string
    name: string
    location: string
}

export default function TestimonialQuote({
    featured,
    name,
    location,
    children,
}: PropsWithChildren<Props>) {
    return (
        <Flex flexDir="column" gridGap={8} py={12}>
            <Spacer />
            <SectionHeading
                as="h3"
                color="white"
                textAlign="left"
                size={{ base: "2xl", xl: "3xl" }}
            >
                {featured}
            </SectionHeading>
            <Paragraph
                fontSize="lg"
                fontWeight="medium"
                fontStyle="italic"
                color="white"
            >
                "{children}"
            </Paragraph>
            <Box alignSelf="flex-end">
                <Subheading
                    textAlign={{ base: "left", md: "right" }}
                    fontSize="xl"
                    fontWeight="bold"
                    color="white"
                >
                    {name}
                </Subheading>
                <Subheading fontWeight="normal" color="white">
                    {location}
                </Subheading>
            </Box>
        </Flex>
    )
}
